import React, { useState } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import './RadioGroup.scss';

function RadioGroup({
    value,
    disabled,
    onChange,
    options
}) {

    const [id] = useState(_.uniqueId());

    return <div className={classNames("radio-group", {disabled: disabled})}>
        {Object.keys(options).map((key) => {
            const label = options[key];
            return <div key={key}>
                <input type="radio" value={key} id={`${id}_${key}`} onChange={() => onChange(key)} name={id} checked={value === key} disabled={disabled} />
                <label htmlFor={`${id}_${key}`}>
                    <span className="box">
                        {value === key && <div className="checked-img" />}
                    </span>
                    {label}
                </label>
            </div>
        })}
    </div>;
}

export default RadioGroup;